import { IApiResponse, IFile } from "../common/commonTypes";
import { IFileDto } from "../common/dtos";
import { authHeader } from "../helpers/authHeader";
import { fetchWrapper } from "../helpers/fetchWrapper";
import { fetchWrapperProtected } from "../helpers/fetchWrapperProtected";
import { getResizedUrl } from "../helpers/imageHelper";
import { getEnv } from "../helpers/env";

const NEXT_PUBLIC_API_URL = getEnv("NEXT_PUBLIC_API_URL");

export const fileService = {
  createFile: async (dto: IFileDto) => {
    const result: IApiResponse = await fetchWrapperProtected.post(
      `${NEXT_PUBLIC_API_URL}/file`,
      dto,
      "application/json"
    );

    return result;
  },

  uploadFile: async (url: string, body: File, contentType: string) => {
    const stringify = false;

    const result: IApiResponse = await fetchWrapper.put(
      url,
      body,
      contentType,
      stringify
    );

    return result;
  },

  updateFile: async (id: string, body?: any) => {
    const response: IApiResponse = await fetchWrapperProtected.put(
      `${NEXT_PUBLIC_API_URL}/file/${id}`,
      body
    );
    return response;
  },

  createAndUploadFile: async (file: File): Promise<IFile> => {
    let mime = file.type;
    const dto: IFileDto = {
      name: file.name,
      mime,
    };
    const { data: createdFileData } = await fileService.createFile(dto);
    await fileService.uploadFile(createdFileData.signed, file, dto.mime);
    await fileService.updateFile(createdFileData.id, { active: true });
    return createdFileData;
  },

  createUploadWithProgressRequest: (
    data: File,
    createdFile: IFile
  ): XMLHttpRequest => {
    const request = new XMLHttpRequest();
    const url = `${createdFile.signed}`;

    request.open("PUT", url, true);
    request.setRequestHeader("Content-type", data.type);
    request.setRequestHeader(
      "Content-Disposition",
      `attachment; filename=${data.name}`
    );
    request.setRequestHeader("x-amz-acl", "public-read");
    const session = authHeader();
    if (session.session) {
      request.setRequestHeader("session", session.session);
    }

    return request;
  },

  uploadFileWithProgress: async (
    data: File | FormData,
    request: XMLHttpRequest,
    onProgress: (e: ProgressEvent) => void
  ): Promise<IFile> => {
    return new Promise((resolve, reject) => {
      request.upload.onprogress = onProgress;
      request.onload = () => {
        if (request.status >= 200 && request.status < 300) {
          resolve(request.response);
        } else {
          reject({
            status: request.status,
          });
        }
      };
      request.onerror = () => {
        reject({
          status: request.status,
        });
      };
      request.onabort = () => {
        reject(new Error("request aborted"));
      };
      request.ontimeout = () => {
        reject(new Error("request aborted"));
      };

      request.send(data);
    });
  },

  generateThumbnails: async (url: string, thumbnailSizes: number[]) => {
    try {
      const promises = thumbnailSizes.map((size) =>
        fetchWrapper.get(getResizedUrl(url, size))
      );

      await Promise.all(promises);
    } catch (error) {}
  },
};
